import { Box, Typography } from "@mui/material";
import Layout from "components/structure/Layout";
import React, { useEffect, useState } from "react";
import { BarChart } from '@mui/x-charts/BarChart';
import { useMsal } from '@azure/msal-react';
import ReportService from "services/ReportService";

const AnalyticalReports = () => {
  const [data, setData] = useState([]) 
   const [height, setHeight] = useState('800px');
  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await ReportService.getReport("Analytical");   
        const activeCropList = response?.data?.response
        setData(activeCropList);
      } catch (error) {
        console.error("Error fetching the report:", error);
      }
    }
    fetchModules()
  }, [])


  return (
    <Layout title={'Agri360 ESG Portal'} style={{ marginBottom: "100px", marginTop: "64px" }}>
    <Box>
    <Typography sx={{ color: ' #102a62' ,fontWeight: 600,fontFamily:'Montserrat',fontSize:'20px'}}>
      Analytical Question Report
    </Typography>
     
    </Box>
    <Box sx={{mt:2}}>
    <iframe title="Farmer"
              width="100%"
              height={height}
              scrolling='no'
              frameBorder='0'
              src={`https://app.powerbi.com/reportEmbed?reportId=${data[0]?.reportType}&autoAuth=true`}
              frameborder="0"
              allowFullScreen="true">
            </iframe>
    </Box>
    </Layout>
   
  );
};

export default AnalyticalReports;
